// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"74":"7c1c20ff","942":"0d7617ad"}[chunkId] + ".chunk.js");